var cov_vwcydu817 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/index.ts",
      hash = "38f562b6265c44f1a7250e7968ea55fd21d35dc9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Image/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 0
        },
        end: {
          line: 4,
          column: 19
        }
      },
      "1": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 35
        }
      },
      "2": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 8,
          column: 46
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Image from './Image';
import Group from './Group';
cov_vwcydu817.s[0]++;
Image.Group = Group;
cov_vwcydu817.s[1]++;
Image.displayName = 'ShineoutImage';
cov_vwcydu817.s[2]++;
Image.Group.displayName = 'ShineoutImageGroup';
export default Image;